import React from 'react';
import { prefix } from '../../../i18n'

const getProp = (field, property) => {
  if (field === undefined) {
    return;
  }
  return field[property]
}

const ExtraForm = ({ onUserChange, errors, extraFields }) => {
  const tRegistry = prefix('registry')

  const extraFieldsPairs = extraFields.flatMap((_, i, a) => i % 2 ? [] : [a.slice(i, i + 2)]);

  const formElements = extraFieldsPairs.map((pair, pairIndex) => {
    return (
      <div key={pairIndex} className="flex template-block between-xs">
        {
          pair.map((field, fieldIndex) => {
            return (
              <div key={fieldIndex} className='w46'>
                <input
                  name={getProp(field, 'field_name')}
                  placeholder={getProp(field, 'field_label')}
                  required={getProp(field, 'required')}
                  type="text"
                  onChange={onUserChange}
                  className="w-full template-blue"
                />
                <p className='w-full my-1 template-hint'>{getProp(field, 'field_hint')}</p>
              </div>
            )
          })
        }
      </div>
    );
  });

  return (
    <>
      <h2 className='py-8 template-title'>{tRegistry('extra-info')}</h2>
      {formElements}
    </>
  )
}

export default ExtraForm
